var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F31919",
    fillRule: "evenodd",
    d: "M6.75 18c0 .69.56 1.25 1.25 1.25h8c.69 0 1.25-.56 1.25-1.25V8h1.5v10A2.75 2.75 0 0 1 16 20.75H8A2.75 2.75 0 0 1 5.25 18V8h1.5v10z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F31919",
    d: "M8 10.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-1.5 0v-5.5zM11.25 10.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-1.5 0v-5.5zM14.5 10.75a.75.75 0 0 1 1.5 0v5.5a.75.75 0 0 1-1.5 0v-5.5z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F31919",
    fillRule: "evenodd",
    d: "M9 3.25A1.75 1.75 0 0 0 7.25 5v1h-2.5a.75.75 0 0 0 0 1.5h14.5a.75.75 0 0 0 0-1.5h-2.5V5A1.75 1.75 0 0 0 15 3.25H9zM15.25 6V5a.25.25 0 0 0-.25-.25H9a.25.25 0 0 0-.25.25v1h6.5z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsDelete);
export default __webpack_public_path__ + "static/media/Icons_Delete.4a76fd2e3f9c3f745143a3b40d2f2028.svg";
export { ForwardRef as ReactComponent };